{
  "goBack": "Volver",
  "layout": {
    "offline": "Sin conexión en este momento.",
    "pageTitle": "Herramientas de comunicación para la coparentalidad | TalkingParents",
    "metaDescription": "TalkingParents es una plataforma de comunicación y coordinación que ofrece herramientas para ayudar a quienes comparten la crianza a enfocarse en sus hijos."
  },
  "footer": { "copyright": "Derechos de autor" },
  "validation": {
    "fieldRequired": "@:common.form.emptyError",
    "invalid": "Este valor no es válido."
  },
  "form": { "chooseOne": "Selecciona una opción", "select": "Seleccionar" },
  "colorMode": {
    "light": "Claro",
    "dark": "Oscuro",
    "systemDefault": "Predeterminado del sistema",
    "lightThemeAlt": "tema claro",
    "darkThemeAlt": "tema oscuro",
    "systemThemeAlt": "tema del sistema"
  },
  "nav": {
    "messaging": "Mensajería Segura",
    "attachments": "Biblioteca de Archivos Adjuntos",
    "calendar": "Calendario Compartido",
    "payments": "Accountable Payments",
    "info": "Biblioteca de Información",
    "records": "Unalterable Records",
    "journal": "Diario Personal",
    "settings": "Configuración de la Cuenta",
    "help": "@:common.links.helpCenter",
    "contact": "@:common.links.contactUs",
    "signout": "Cerrar Sesión",
    "tryNewLook": "Pruebe el nuevo interfaz!",
    "tryNewLook_sm": "Nuevo interfaz!",
    "feedback": "Comparte tus comentarios",
    "vault": "Archivos en la Bóveda",
    "calling": "Accountable Calling",
    "observerSectionsAriaLabel": "Secciones del observador"
  },
  "signOutModal": {
    "header": "¿Seguro que quieres cerrar sesión?",
    "content": "Se perderán todos los borradores de mensajes.",
    "cancelButton": "@:common.actions.cancel",
    "confirmButton": "Cerrar sesión"
  },
  "titles": {
    "messaging": "Mensajes con {name}",
    "messagingMobile": "Mensajería",
    "attachments": "Biblioteca de Archivos Adjuntos",
    "calendar": "Calendario Compartido",
    "payments": "Accountable Payments",
    "info": "Biblioteca de Información",
    "records": "Unalterable Records",
    "journal": "Diario Personal",
    "settings": "Configuración de la Cuenta",
    "help": "@:common.links.helpCenter",
    "contact": "@:common.links.contactUs",
    "vault": "Archivos en la Bóveda",
    "calling": "Accountable Calling"
  },
  "errorModal": {
    "header": "Hubo un error...",
    "fixError": "Corrige el error a continuación y vuelve a intentarlo. Si el problema persiste, contáctanos en {contact}.",
    "errorText": "Error: {error}",
    "genericError": "Verifica tu conexión y vuelve a intentarlo. Si el problema persiste, contáctanos en {contact}."
  },
  "characterLimitReached": "Se alcanzó el límite de caracteres ({over}).",
  "dropzone": {
    "title": "Arrastra y suelta archivos o selecciona para buscarlos",
    "subtitle": "Máximo: {count} archivos, {size} cada uno",
    "mobileTitle": "Agregar archivos adjuntos | Agregar archivos adjuntos ({count}) | Agregar archivos adjuntos ({count})",
    "errors": {
      "header": "No se pudo agregar el archivo adjunto",
      "illegalCharacters": {
        "title": "No se pudo agregar el archivo adjunto porque el nombre del archivo no es válido.",
        "subtitle": "El nombre del archivo no debe contener los siguientes caracteres: {characters}"
      },
      "illegalExtension": {
        "title": "No se pudo agregar el archivo adjunto porque este tipo de archivo no es aceptado.",
        "subtitle": "Tipos de archivo aceptados: {types}"
      },
      "fileSizeTooBig": {
        "title": "El archivo es demasiado grande ({size}).",
        "subtitle": "Tamaño máximo: {size}."
      },
      "tooManyFiles": "Solo puede adjuntar 5 archivos por mensaje. No puede cargar más archivos."
    }
  },
  "attachFromVault": {
    "title": "Insertar archivos desde la Bóveda",
    "upgradeModal": {
      "header": "Mejora tu plan para acceder a los archivos en la Bóveda",
      "content": "Almacena una gran variedad de archivos de forma privada y segura. Igual que en la nube, puedes compartir enlaces a archivos directamente desde tu Bóveda.",
      "upgradeButton": "@:common.actions.upgrade"
    }
  },
  "serviceMark": "SM",
  "banners": {
    "restrictedCoParent": "El otro progenitor no tiene una suscripción activa.",
    "restrictedCoParentLearnMore": "@:common.links.learnMore"
  },
  "introPages": {
    "continue": "@:common.actions.continue",
    "upgradeButton": "@:common.actions.upgrade"
  },
  "search": { "placeholder": "@:common.list.search" },
  "downloads": {
    "inProgressCancelModal": {
      "header": "Cancelar descargas",
      "content": "Algunos elementos aún se están descargando. ¿Deseas detener todas las descargas?",
      "cancelButton": "@:common.actions.cancel",
      "confirmButton": "@:common.actions.confirm"
    },
    "list": {
      "headerSingle": "Descargando 1 elemento",
      "headerMultiple": "Descargando {count} elementos",
      "headerSingleCompleted": "Se descargó 1 elemento",
      "headerMultipleCompleted": "Se descargó {count} elementos",
      "item": {
        "issue": "Hubo un error al descargar tu archivo. Intenta nuevamente.",
        "completed": "Completado",
        "reDownload": "Volver a descargar"
      }
    }
  },
  "uploads": {
    "list": {
      "headerSingle": "Cargando 1 elemento",
      "headerMultiple": "Cargando {count} elementos",
      "headerSingleCompleted": "Se cargó 1 elemento",
      "headerMultipleCompleted": "Se cargaron {count} elementos",
      "item": {
        "converting": "Convirtiendo...",
        "issue": "Se produjo un error al cargar el archivo. Intente nuevamente.",
        "pause": "Pausar",
        "resume": "Reanudar carga",
        "completed": "Completado",
        "failed": "Error"
      }
    }
  },
  "errors": {
    "existingSubscriptionTitle": "Suscripción activa existente",
    "existingSubscriptionMessage": "Tu cuenta ya tiene una suscripción activa en TalkingParents. Contacta a soporte para obtener ayuda.",
    "codes": {
      "sendVerificationCode": {
        "invalidPhoneNumber": "@:common.form.invalidPhoneNumber",
        "tooManyAttempts": "Demasiados intentos. Intenta más tarde o contacta a soporte para obtener ayuda."
      },
      "confirmVerificationCode": {
        "tooManyAttempts": "Superaste el número máximo de intentos de verificación. Intenta de nuevo en 30 segundos.",
        "invalidCode": "El código de verificación es incorrecto.",
        "expiredCode": "El código de verificación venció."
      },
      "enableMfaSms": {
        "phoneNotVerified": "Verifica tu número de teléfono antes de activar la autenticación multifactor.",
        "tooManyAttempts": "Demasiados intentos. Intenta más tarde o contacta a soporte para obtener ayuda.",
        "alreadyEnabled": "La autenticación multifactor ya está activada con el número de teléfono asociado a tu cuenta.",
        "invalidPhoneNumber": "Ingresa un número de teléfono válido."
      },
      "confirmEnableMfaSms": {
        "tooManyAttempts": "Superaste el número máximo de intentos de verificación. Intenta de nuevo en 30 segundos.",
        "invalidRequest": "La solicitud para activar la autenticación multifactor no es válida.",
        "expiredCode": "El código de verificación venció.",
        "invalidCode": "El código de verificación es incorrecto.",
        "alreadyEnabled": "La autenticación multifactor ya está activada con el número de teléfono asociado a tu cuenta."
      },
      "disableMfaSms": {
        "alreadyDisabled": "La autenticación multifactor ya está desactivada."
      }
    }
  },
  "states": {
    "label": "@:common.form.labels.state",
    "defaultOption": "@:form.select",
    "errorMessage": "Selecciona un estado",
    "al": "Alabama",
    "ak": "Alaska",
    "az": "Arizona",
    "ar": "Arkansas",
    "ca": "California",
    "co": "Colorado",
    "ct": "Connecticut",
    "de": "Delaware",
    "dc": "District of Columbia",
    "fl": "Florida",
    "ga": "Georgia",
    "hi": "Hawaii",
    "id": "Idaho",
    "il": "Illinois",
    "in": "Indiana",
    "ia": "Iowa",
    "ks": "Kansas",
    "ky": "Kentucky",
    "la": "Louisiana",
    "me": "Maine",
    "md": "Maryland",
    "ma": "Massachusetts",
    "mi": "Michigan",
    "mn": "Minnesota",
    "ms": "Mississippi",
    "mo": "Missouri",
    "mt": "Montana",
    "ne": "Nebraska",
    "nv": "Nevada",
    "nh": "New Hampshire",
    "nj": "New Jersey",
    "nm": "New Mexico",
    "ny": "New York",
    "nc": "North Carolina",
    "nd": "North Dakota",
    "oh": "Ohio",
    "ok": "Oklahoma",
    "or": "Oregon",
    "pa": "Pennsylvania",
    "ri": "Rhode Island",
    "sc": "South Carolina",
    "sd": "South Dakota",
    "tn": "Tennessee",
    "tx": "Texas",
    "ut": "Utah",
    "vt": "Vermont",
    "va": "Virginia",
    "wa": "Washington",
    "wv": "West Virginia",
    "wi": "Wisconsin",
    "wy": "Wyoming"
  },
  "searchFilterBar": {
    "buttonScreenReader": "Ordenar y filtrar",
    "search": {
      "searchButtonScreenReader": "@:common.list.search",
      "clearButtonScreenReader": "Borrar",
      "ariaLabel": "Buscar en el contenido del sitio"
    },
    "filter": {
      "mobileButtonScreenReader": "Filtrar por tipo",
      "desktopButton": "Tipo",
      "modalHeader": "Filtros"
    },
    "dateRange": {
      "mobileButtonScreenReader": "Filtrar por rango de fechas",
      "desktopButton": "Fecha",
      "modalHeader": "Rango de fechas",
      "subtitle": "Rango de fechas"
    },
    "sort": {
      "mobileButtonScreenReader": "@:common.list.sortBy",
      "desktopButton": "Ordenar",
      "modalHeader": "Orden",
      "subtitle": "@:common.list.sortBy"
    },
    "selectedFilters": {
      "filteringByTypeOrStartDateOnly": "Filtrado por: {filter}",
      "filteringByDateRangeOnly": "Filtrado por: {start} - {end}",
      "filteringByBothStartDate": "Filtrado por: {filter}, {start}",
      "filteringByBothRange": "Filtrado por: {filter}, {start} - {end}",
      "filterBy": "Filtrar por: {filter}",
      "sortingBy": "Ordenar por: {sort}",
      "none": "Ninguno",
      "clearAll": "Borrar todo",
      "clearFilter": "Borrar filtro",
      "clearSort": "Borrar orden",
      "clearDates": "Borrar fechas",
      "noCountFound": "No se encontraron resultados para {search}."
    },
    "resetButton": "@:common.actions.reset",
    "applyButton": "@:common.actions.apply"
  },
  "aiUpsell": {
    "title": "Funciones de IA",
    "description": "Asistencia con IA para mejorar tu experiencia.",
    "ctaText": "Acceda con el plan Ultimate",
    "responseLabel": "Respuesta sugerida por IA:",
    "examplePromptSr": "Ejemplo de mensaje del usuario:"
  },
  "landingPage": {
    "signIn": "Iniciar sesión",
    "getStarted": "Comenzar",
    "followUs": "Síganos",
    "termsOfService": "Términos del servicio",
    "privacyPolicy": "Política de privacidad"
  },
  "notFound": {
    "title": "Página no encontrada",
    "text": "La página que busca no está disponible.",
    "goHomeCta": "Ir al inicio",
    "contactUsCta": "@:common.links.contactUs",
    "logoTitle": "Ir a la página principal de TalkingParents.",
    "logoAlt": "Logotipo de TalkingParents"
  },
  "pdfDownload": {
    "title": "Registro PDF",
    "downloadSuccess": "Descargaste el registro en PDF correctamente.",
    "inputPrompt": "Ingresa el código de acceso de 6 caracteres que recibiste en tu correo electrónico para descargar tu registro.",
    "requiredField": "@:common.form.requiredIndicator",
    "accessCodeLabel": "Código de acceso",
    "submitCodeCta": "@:common.actions.submit",
    "apiError": "No se pudo acceder al registro"
  },
  "newsletter": {
    "signup": {
      "title": "Mantente al día con las novedades de la coparentalidad",
      "description": "Recibe consejos de coparentalidad, información de expertos del sector, novedades sobre nuevas funciones y más, directamente en tu bandeja de entrada de correo electrónico.",
      "requiredField": "@:common.form.requiredIndicator",
      "emailLabel": "Correo electrónico",
      "signUpCta": "Suscribirme"
    },
    "welcome": {
      "title": "¡Bienvenido a nuestra comunidad de coparentalidad!",
      "description": "Diste el siguiente paso para facilitar la coparentalidad. Ahora tienes acceso a recursos sobre crianza que cubren una gran variedad de temas, a los seminarios web de Co-parenting & Coffee con expertos y otros progenitores como tú, y a las últimas novedades de TalkingParents.",
      "updatePreferencesDesc": "Actualiza tus preferencias en cualquier momento desde la página de suscripción.",
      "updatePreferencesCta": "Actualizar preferencias",
      "parentingResourcesCta": "Ir a los recursos para la coparentalidad"
    },
    "preferencesUpdated": {
      "title": "Preferencias actualizadas.",
      "description": "Se actualizaron las preferencias según lo solicitado. Disfruta de este boletín personalizado.",
      "resourcesDescription": "Consulta la colección de recursos de crianza disponible"
    }
  },
  "login": {
    "title": "Iniciar sesión {sr}",
    "titleSr": "de tu cuenta",
    "metaDescription": "Inicia sesión en TalkingParents o crea tu cuenta ahora",
    "offlineError": "Sin conexión en este momento.",
    "emailLabel": "Correo electrónico",
    "passwordLabel": "Contraseña",
    "forgotPasswordCta": "¿Olvidaste tu correo electrónico o contraseña?",
    "contactUsCta": "@:common.links.contactUs",
    "signupCta": "Crear cuenta",
    "loginStatus": "Iniciando sesión...",
    "signInButton": "Iniciar sesión",
    "errors": {
      "invalidCredentials": "El nombre de usuario o la contraseña no son correctos.",
      "lockedOut": "Demasiados intentos incorrectos. Intenta más tarde.",
      "tooManyIncorrectAttempts": "Demasiados intentos incorrectos. Intenta más tarde.",
      "tooManyLoginAttempts": "Demasiados intentos de inicio de sesión. Intenta más tarde.",
      "userDisabled": "Esta cuenta de usuario está desactivada."
    },
    "mfaErrors": {
      "lockedOut": "Alcanzaste el número máximo de intentos de verificación en 24 horas para este número de teléfono. Si necesitas ayuda, contacta a soporte.",
      "exceededCodeAttempts": "Alcanzaste el número máximo de intentos para este código. Envía otro código. Si necesitas ayuda, contacta a soporte.",
      "invalidCode": "El código de autenticación no es válido."
    }
  },
  "resetPassword": {
    "title": "Restablecer contraseña {sr}",
    "updatedTitle": "Contraseña actualizada {sr}",
    "srTitle": "de tu cuenta",
    "stepOne": {
      "title": "Elija una nueva contraseña",
      "newPassword": {
        "label": "@:common.form.labels.newPassword",
        "hint": "@:password.hint"
      },
      "verifyPassword": {
        "label": "Verificar contraseña",
        "hint": "Vuelva a ingresar la nueva contraseña",
        "noMatchError": "Las contraseñas no coinciden."
      },
      "updatePasswordCta": "Actualizar contraseña"
    },
    "stepTwo": {
      "updateSuccessText": "La contraseña fue actualizada exitosamente.",
      "loginText": "Ahora puedes iniciar sesión con tu nueva contraseña.",
      "returnToLoginCta": "Volver a iniciar sesión"
    },
    "resetError": {
      "text": "Este enlace ha expirado o no es válido.",
      "requestNewLink": "Solicitar nuevo enlace"
    }
  },
  "forgotPassword": {
    "title": "¿Olvidaste tu correo electrónico o contraseña? {sr}",
    "titleSr": "de tu cuenta",
    "description": "Ingresa el correo electrónico o el número de celular asociado a la cuenta. Te enviaremos un enlace para restablecer tu contraseña.",
    "email": {
      "label": "Ingresa tu correo electrónico",
      "submitCta": "Enviar",
      "forgotEmailInstructions": {
        "label": "Si no recuerda el correo electrónico",
        "stepOne": "Ingresa posibles direcciones y selecciona Enviar después de cada intento.",
        "stepTwo": "Revisa tus bandejas de entrada de correo para el restablecimiento."
      }
    },
    "mobile": {
      "label": "Número de celular",
      "sendCodeCta": "@:common.actions.sendCode"
    },
    "verifyCode": {
      "description": "Se envió un código de 6 dígitos a {phone}",
      "resentSuccess": "Código reenviado",
      "lengthError": "El código debe tener 6 dígitos",
      "errors": {
        "codeNotValid": "El código no coincide. Revísalo e intenta de nuevo.",
        "userDisabled": "Esta cuenta de usuario está desactivada.",
        "multipleAccountsFound": "Se encontraron varias cuentas con el número de celular: {mobilePhone}",
        "tooManyAttempts": "Demasiados intentos. Intenta más tarde o contacta a soporte para obtener ayuda."
      }
    },
    "emailSentModal": {
      "title": "Instrucciones enviadas",
      "description": "Se enviaron instrucciones para restablecer la contraseña si el correo electrónico existe en el sistema. Revise también la carpeta de correo no deseado.",
      "okayCta": "@:common.actions.okay"
    },
    "helpCenterCta": "¿Necesita ayuda para iniciar sesión?"
  },
  "password": {
    "requirement": "Ingresa una contraseña con al menos 10 caracteres, una letra, un número y un carácter especial.",
    "hint": "Debes tener al menos 10 caracteres, una letra, un número y un carácter especial.",
    "toggle": { "show": "Mostrar", "hide": "Ocultar" }
  },
  "accessibility": { "settings": "Configuración" },
  "common": {
    "undo": "Deshacer",
    "tierCard": {
      "ultimate": {
        "bullets": [
          "Minutos de llamada ilimitados",
          "50 GB de almacenamiento en la Bóveda",
          "Registros en PDF ilimitados",
          "Soporte prioritario",
          "Pago exprés",
          "Sentiment Scanner + Writing Assist℠"
        ]
      },
      "enhanced": {
        "bullets": [
          "{minutes} minutos de llamadas",
          "15 GB de almacenamiento en la Bóveda",
          "Registros en PDF ilimitados"
        ]
      },
      "essentials": {
        "bullets": [
          "{minutes} minutos de llamadas",
          "1 GB de almacenamiento en la Bóveda"
        ]
      }
    },
    "actions": {
      "cancel": "Cancelar",
      "okay": "Aceptar",
      "close": "Cerrar",
      "yes": "Sí",
      "no": "No",
      "continue": "Continuar",
      "send": "Enviar",
      "retry": "Reintentar",
      "save": "Guardar",
      "delete": "Eliminar",
      "edit": "Editar",
      "remove": "Eliminar",
      "removeInline": "eliminar",
      "confirm": "Confirmar",
      "done": "Listo",
      "notNow": "Ahora no",
      "upgrade": "Mejorar",
      "goBack": "Volver",
      "editPhoneNumber": "Editar número de teléfono",
      "verify": "Verificar",
      "accept": "Aceptar",
      "apply": "Aplicar",
      "sendCode": "Enviar código",
      "upgradePlan": "Mejorar plan",
      "reset": "Restablecer",
      "submit": "Enviar"
    },
    "mfa": {
      "enableTitle": "Activar autenticación multifactor",
      "label": "Autenticación multifactor",
      "phoneVerifiedToast": "Número de celular verificado.",
      "codeSentText": "Código de verificación enviado a {phoneNumber}"
    },
    "list": {
      "sortBy": "Ordenar por",
      "filterBy": "Filtrar por",
      "resetFilters": "Restablecer filtros",
      "search": "Buscar",
      "newestToOldest": "Más recientes primero",
      "oldestToNewest": "Más antiguos primero",
      "noResultsFound": "No se encontraron resultados"
    },
    "links": {
      "helpCenter": "Centro de Ayuda",
      "learnMore": "Más información",
      "privacyPolicy": "Política de Privacidad",
      "termsOfService": "Términos de Servicio",
      "contactSupport": "Contacta a soporte",
      "contactUs": "Contáctanos"
    },
    "plans": {
      "free": "Free",
      "essentials": "Essentials",
      "standard": "Standard",
      "enhanced": "Enhanced",
      "premium": "Premium",
      "ultimate": "Ultimate",
      "billing": { "monthly": "Mensual", "annual": "Anual" }
    },
    "copyright": "Derechos de autor © 2012 - {year} Monitored Communications, LLC",
    "planNames": {
      "free": "Plan Free",
      "essentials": "Plan Essentials",
      "standard": "Plan Standard",
      "enhanced": "Plan Enhanced",
      "premium": "Plan Premium",
      "ultimate": "Plan Ultimate"
    },
    "phoneErrors": {
      "required": "@:common.form.invalidPhoneNumber",
      "possible": "La longitud del número es válida para esta región.",
      "invalidCountryCode": "El código de país no es válido.",
      "tooShort": "El número es demasiado corto para esta región.",
      "tooLong": "El número es demasiado largo para esta región.",
      "possibleLocalOnly": "Es posible que a este número le falte el código de área.",
      "invalidLength": "La longitud del número no es válida para esta región.",
      "invalidNumber": "@:common.form.invalidPhoneNumber"
    },
    "textInputErrors": {
      "emailRequired": "Ingresa un correo electrónico.",
      "invalidEmail": "Ingresa un correo electrónico válido.",
      "invalidZipCode": "Ingresa un código postal válido."
    },
    "dateTime": { "formatted": "{date} a la {time} | {date} a las {time}" },
    "dateFormatNames": {
      "unitedStates": "Inglés (Estados Unidos)",
      "canada": "Inglés (Canadá)",
      "australia": "Inglés (Australia)",
      "unitedKingdom": "Inglés (Reino Unido)"
    },
    "form": {
      "emptyError": "Este campo es obligatorio.",
      "passwordMismatch": "Las contraseñas no coinciden.",
      "invalidPhoneNumber": "Ingresa un número de teléfono válido.",
      "phoneNumberRequired": "Ingresa un número de teléfono.",
      "requiredIndicator": "campo obligatorio",
      "labels": {
        "email": "Correo electrónico",
        "firstName": "Nombre",
        "lastName": "Apellido",
        "name": "Nombre",
        "password": "Contraseña",
        "newPassword": "Nueva contraseña",
        "address": "Dirección",
        "streetAddress": "Dirección",
        "city": "Ciudad",
        "state": "Estado",
        "phoneNumber": "Número de teléfono",
        "zipCode": "Código postal"
      }
    }
  },
  "notifications": {
    "professionalApprovalRequired": {
      "title": "Se requiere aprobación",
      "description": "{name} aceptó tu invitación. Revisa el acceso para completar la conexión.",
      "reviewRequest": "Revisar solicitud"
    }
  }
}
